import {Injectable, Type} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    CampaignTypeConfigObjectComponent
} from "../../component/protected-components/object-component/campaign-type-config-object-component/campaign-type-config-object.component";

@Injectable({
    providedIn: 'root'
})
export class CampaignTypeConfigService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignTypeConfigs')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-cog';
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {

        if (mode != MvsCrudModeEnum.create) {
            return CampaignTypeConfigObjectComponent;
        }
        return null
    }
}
